import React, { forwardRef } from "react";

import { format } from "date-fns";

import {
  Box,
  Flex,
  Spacer,
  Text,
  HStack,
  Stack,
  List,
  ListItem,
  SimpleGrid,
} from "@chakra-ui/react";
import logoMCA from "../../../img-docs/logomca.png";

import { IrmaoTable } from "../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
import SemRegistros from "../SemRegistros";
import { RiPushpinLine } from "react-icons/ri";

export const ComponentToPrintRelatorioCriancaGeral = forwardRef(
  (props, ref) => {
    const renderSN = (value) => {
      if (!value || value.length === 0) return "";

      const hasS = value.includes("S");
      const hasN = value.includes("N");

      if (hasS && hasN) return " Sim e Não";
      if (hasS) return " Sim";
      if (hasN) return " Não";

      return "";
    };

    const columnsOrgaos = [
      props?.storage?.idMunicipioOrgao?.[0]?.length > 0,
      props?.storage?.idPromotoriaOrgaos?.[0]?.length > 0,
      props?.storage?.idVaraOrgaos?.[0]?.length > 0,
    ].filter(Boolean).length;

    return (
      <Box display="block" ref={ref}>
        <table style={{ width: props?.dataPendencias?.length <= 0 && "100%" }}>
          <thead>
            <tr>
              <td>
                {/* Header Spacer */}
                <Box height="100px" />
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Box display="break-page">
                  <Stack alignItems="center" px={10}>
                    <Text fontSize={"3xl"} fontWeight={700} color="#6A6A6A">
                      Relatório de Crianças e Adolescentes
                    </Text>
                    <Text>{""}</Text>

                    {props?.dataPendencias?.length > 0 ? (
                      <Box display={"block"}>
                        <IrmaoTable
                          mt={"0px"}
                          columns={props.columnsPendencias}
                          data={props.dataPendencias}
                          entidade="relatorio-crianca-adolescente-geral"
                          disableHeaderOptions={true}
                          isPrint={true}
                        />
                        <Text mt={4}>
                          Total de Registro(s):{" "}
                          {props?.storage?.totalItems ?? 0}
                        </Text>
                      </Box>
                    ) : (
                      <Box w={"full"} display={"block"}>
                        <SemRegistros buttonVisible={true} half />
                      </Box>
                    )}
                  </Stack>
                  <Box px={10} py={20}>
                    <Text
                      fontSize={"3xl"}
                      fontWeight={700}
                      color="#6A6A6A"
                      textAlign={"center"}
                    >
                      Filtros Preenchidos
                    </Text>
                    <Text>{""}</Text>
                    <Flex
                      direction="column"
                      borderRadius="12px"
                      boxShadow="0px 24px 40px 0px #00000014"
                      border="1px solid #00000014"
                      mt={4}
                      p={10}
                    >
                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Universo da Consulta
                        </Text>
                        {(!!props?.storage?.universoConsulta ||
                          (!!props?.storage?.idsMotivosEntrada &&
                            props?.storage?.idsMotivosEntrada?.length > 0) ||
                          !!props?.storage?.idTipoTransferencia ||
                          (!!props?.storage?.idJustificativas &&
                            props?.storage?.idJustificativas?.length > 0) ||
                          (!!props?.storage?.dataInicio &&
                            !!props?.storage?.dataFim)) && (
                          <>
                            <SimpleGrid
                              columns={
                                props?.storage?.idsMotivosEntrada?.length > 0 ||
                                !!props?.storage?.idTipoTransferencia
                                  ? 3
                                  : 2
                              }
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Universo
                              </Text>
                              {props?.storage?.idsMotivosEntrada?.[0]?.length >
                                0 && (
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Motivo
                                </Text>
                              )}
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Período
                              </Text>
                              {props?.storage?.idTipoTransferencia && (
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Tipo de Transferência
                                </Text>
                              )}
                              <Box>
                                <Text borderBottom="1px solid #00000014" p={1}>
                                  {props?.storage?.universoConsulta === 1
                                    ? "Acolhido"
                                    : props?.storage?.universoConsulta === 2
                                      ? "Desligado"
                                      : props?.storage?.universoConsulta === 3
                                        ? "Transferência"
                                        : props?.storage?.universoConsulta === 4
                                          ? "Pendente"
                                          : ""}
                                </Text>
                              </Box>

                              {props?.storage?.idsMotivosEntrada?.[0]?.length >
                                0 && (
                                <Box>
                                  <Text
                                    borderBottom="1px solid #00000014"
                                    p={1}
                                  >
                                    {props?.storage?.idsMotivosEntrada?.[0]
                                      ?.map((e) => e.descricao)
                                      .join(", ")}
                                  </Text>
                                </Box>
                              )}

                              <Box>
                                {props?.storage?.dataInicio &&
                                props?.storage?.dataFim ? (
                                  <Text
                                    borderBottom="1px solid #00000014"
                                    p={1}
                                  >
                                    De {props?.storage?.dataInicio} Até{" "}
                                    {props?.storage?.dataFim}
                                  </Text>
                                ) : (
                                  <Text
                                    borderBottom="1px solid #00000014"
                                    p={1}
                                  >
                                    Situação Atual
                                  </Text>
                                )}
                              </Box>

                              {!!props?.storage?.idTipoTransferencia && (
                                <Box>
                                  <Text
                                    borderBottom="1px solid #00000014"
                                    p={1}
                                  >
                                    {props?.storage?.idTipoTransferencia?.label}
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                            <SimpleGrid
                              columns={1}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {props?.storage?.idJustificativas?.[0]?.length >
                                0 && (
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Justificativas
                                </Text>
                              )}

                              {props?.storage?.idJustificativas?.[0]?.length >
                                0 && (
                                <Box>
                                  <Text
                                    borderBottom="1px solid #00000014"
                                    p={1}
                                  >
                                    {props?.storage?.idJustificativas?.[0]
                                      ?.map((e) => e.descricao)
                                      .join(", ")}
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                          </>
                        )}
                      </Box>
                    </Flex>
                    <Flex
                      direction="column"
                      borderRadius="12px"
                      boxShadow="0px 24px 40px 0px #00000014"
                      border="1px solid #00000014"
                      mt={4}
                      p={10}
                    >
                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Localização do Serviço de Acolhimento
                        </Text>
                        <SimpleGrid columns={4} spacing={3} w="100%" mt={10}>
                          {/* HEADER */}
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Estado
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Município
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Bairro
                          </Text>
                          <Text
                            fontWeight="bold"
                            color="#169499"
                            borderBottom="1px solid #00000014"
                          >
                            Nome do Serviço de Acolhimento
                          </Text>

                          {/* LINHA ÚNICA */}
                          <Text borderBottom="1px solid #00000014">
                            {props?.storage?.idEstado?.[0]
                              ?.map((e) => e.nome)
                              .join(", ") || "Todos"}
                          </Text>

                          <Text borderBottom="1px solid #00000014">
                            {props?.storage?.idMunicipio?.[0]?.[0]
                              ?.descricao === "Todos"
                              ? "Todos"
                              : props?.storage?.idMunicipio?.[0]
                                  ?.map((m) => m.descricao)
                                  .join(", ") || "Todos"}
                          </Text>

                          <Text borderBottom="1px solid #00000014">
                            {props?.storage?.idBairro?.[0]?.[0]?.descricao ===
                            "Todos"
                              ? "Todos"
                              : props?.storage?.idBairro?.[0]
                                  ?.map((b) => b.descricao)
                                  .join(", ") || "Todos"}
                          </Text>

                          <Text borderBottom="1px solid #00000014">
                            {props?.storage?.idsServicosAcolhimento?.[0]
                              ?.map((e) => e.nomeFantasia)
                              .join(", ") || "Todos"}
                          </Text>
                        </SimpleGrid>
                      </Box>

                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Orgãos
                        </Text>

                        {((props?.storage?.idMunicipioOrgao?.length ?? 0) > 0 ||
                          (props?.storage?.idPromotoriaOrgaos?.length ?? 0) >
                            0 ||
                          (props?.storage?.idVaraOrgaos?.length ?? 0) > 0) && (
                          <SimpleGrid
                            columns={columnsOrgaos}
                            spacing={3}
                            w="100%"
                            mt={10}
                          >
                            {/* HEADER */}

                            {props?.storage?.idMunicipioOrgao?.[0]?.length >
                              0 && (
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Município
                              </Text>
                            )}

                            {props?.storage?.idPromotoriaOrgaos?.[0]?.length >
                              0 && (
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Promotoria de Justiça
                              </Text>
                            )}

                            {props?.storage?.idVaraOrgaos?.[0]?.length > 0 && (
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Vara da Infância
                              </Text>
                            )}

                            {/* LINHA ÚNICA */}
                            {props?.storage?.idMunicipioOrgao?.[0]?.length >
                              0 && (
                              <Text borderBottom="1px solid #00000014">
                                {props?.storage?.idMunicipioOrgao?.[0]
                                  ?.map((e) => e.descricao)
                                  .join(", ")}
                              </Text>
                            )}

                            {props?.storage?.idPromotoriaOrgaos?.[0]?.length >
                              0 && (
                              <Text borderBottom="1px solid #00000014">
                                {props?.storage?.idPromotoriaOrgaos?.[0]
                                  ?.map((m) => m.descricao)
                                  .join(", ")}
                              </Text>
                            )}

                            {props?.storage?.idVaraOrgaos?.[0]?.length > 0 && (
                              <Text borderBottom="1px solid #00000014">
                                {props?.storage?.idVaraOrgaos?.[0]
                                  ?.map((e) => e.descricao)
                                  .join(", ")}
                              </Text>
                            )}
                          </SimpleGrid>
                        )}

                        {!!props?.storage
                          ?.radioCriterioAtribuicaoCompetencia && (
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                              mt={6}
                            >
                              Critério de Atribuição
                            </Text>
                            <List styleType="disc" p={5}>
                              <ListItem>
                                {props?.storage
                                  ?.radioCriterioAtribuicaoCompetencia === "C"
                                  ? "Órgão que consta na Ficha Criança ou Adolescente "
                                  : props?.storage
                                        ?.radioCriterioAtribuicaoCompetencia ===
                                      "S"
                                    ? "Órgão que consta na Ficha do Serviço de Acolhimento "
                                    : props?.storage
                                          ?.radioCriterioAtribuicaoCompetencia ===
                                        "SC"
                                      ? "Mesmo Órgão na Ficha da Criança ou Adolescente e Ficha do Serviço de Acolhimento "
                                      : ""}
                              </ListItem>
                            </List>
                          </>
                        )}
                      </Box>

                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Dados Básicos
                        </Text>
                        {((props?.storage?.idGenero?.length ?? 0) > 0 ||
                          (props?.storage?.idRaca?.length ?? 0) > 0) && (
                          <SimpleGrid columns={2} spacing={3} w="100%" mt={10}>
                            {/* HEADER */}

                            {props?.storage?.idGenero?.[0]?.length > 0 && (
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Gênero
                              </Text>
                            )}

                            {props?.storage?.idRaca?.[0]?.length > 0 && (
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Raça/Cor
                              </Text>
                            )}

                            {/* LINHA ÚNICA */}
                            <Text>
                              {props?.storage?.idGenero?.[0]
                                ?.map((e) => e.genero || e?.descricao)
                                .join(", ")}
                            </Text>

                            <Text>
                              {props?.storage?.idRaca?.[0]
                                ?.map((m) => m.raca || m?.descricao)
                                .join(", ")}
                            </Text>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.idadeInicial ||
                          props?.storage?.idadeFinal) && (
                          <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Faixa Etária Pesquisada
                            </Text>

                            <Text>
                              {props?.storage?.idadeInicial &&
                                `De: ${props?.storage?.idadeInicial} Anos`}{" "}
                              {props?.storage?.idadeFinal &&
                                `Até 
                                                   ${props?.storage?.idadeFinal} Anos`}
                            </Text>
                          </SimpleGrid>
                        )}
                        {props?.storage?.pesquisarFichas?.length > 0 && (
                          <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Fichas
                            </Text>

                            <Text>
                              {props?.storage?.pesquisarFichas.includes("S") &&
                                "Cadastros com Nome Social"}
                            </Text>
                            <Text>
                              {props?.storage?.pesquisarFichas.includes("F") &&
                                " Cadastros com Nome Fictício"}
                            </Text>
                            <Text>
                              {props?.storage?.pesquisarFichas.includes("N") &&
                                "Cadastro com Data de Nascimento Estimada"}
                            </Text>
                          </SimpleGrid>
                        )}
                      </Box>

                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Referência Familiar e Comunitária
                        </Text>
                        {(props?.storage?.idTipoReferencia?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo de Referência
                            </Text>

                            <Text>
                              {props?.storage?.idTipoReferencia?.[0]
                                ?.map((e) => e.label || e?.descricao)
                                .join(", ") || "Todos"}
                            </Text>
                          </SimpleGrid>
                        )}
                        {props?.storage?.nomeReferencia && (
                          <SimpleGrid columns={1} spacing={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Nome da Referência Familiar
                            </Text>

                            <Text>{props?.storage?.nomeReferencia}</Text>
                          </SimpleGrid>
                        )}
                        {props?.storage?.detalhamentoIrmaos?.length > 0 && (
                          <>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                              mt={6}
                            >
                              Detalhamento de Irmãos
                            </Text>
                            <List styleType="disc" p={5}>
                              <ListItem>
                                {props?.storage?.detalhamentoIrmaos.includes(
                                  "A",
                                ) &&
                                  "Irmão(s) acolhido(s) no mesmo serviço de acolhimento. "}
                              </ListItem>
                              <ListItem>
                                {props?.storage?.detalhamentoIrmaos.includes(
                                  "AD",
                                ) &&
                                  "Irmão(s) acolhido(s) em serviço(s) de acolhimento diferente(s). "}
                              </ListItem>
                              <ListItem>
                                {props?.storage?.detalhamentoIrmaos.includes(
                                  "H",
                                ) && "Irmão(s) sem histórico de acolhimento. "}
                              </ListItem>
                              <ListItem>
                                {props?.storage?.detalhamentoIrmaos.includes(
                                  "D",
                                ) && "Irmão(s) desligado(s). "}
                              </ListItem>
                            </List>
                          </>
                        )}
                      </Box>

                      <Box display="break-page">
                        <Text
                          borderBottom="3px solid #169499"
                          pb={2}
                          as="b"
                          fontSize={"18px"}
                          display="inline-flex"
                          alignItems="center"
                          gap={2}
                          mr={2}
                          mt={10}
                          w="fit-content"
                        >
                          <RiPushpinLine size={20} />
                          Saúde
                        </Text>
                        {(props?.storage?.radioDeficiencia?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {/* HEADER */}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Deficiência
                            </Text>

                            <Text p={1}>
                              {renderSN(props?.storage.radioDeficiencia)}
                            </Text>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.deficiencias?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Tipo Deficiência
                            </Text>

                            <List styleType="disc" px={5}>
                              {props?.storage.deficiencias[0].map((e) => (
                                <ListItem key={e?.idTipoDeficiencia || e?.id}>
                                  {e?.descricaoTipoDeficiencia || e?.descricao}
                                </ListItem>
                              ))}
                            </List>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.radioProblemaSaude?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Problema de Saúde
                            </Text>
                            <Text p={1}>
                              {renderSN(props?.storage.radioProblemaSaude)}
                            </Text>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.doencas?.length ?? 0) > 0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Doenças
                            </Text>
                            <List styleType="disc" px={5}>
                              {props?.storage.doencas[0].map((e) => (
                                <ListItem key={e.idDoenca || e.id}>
                                  {e?.descricaoDoenca || e?.descricao}
                                </ListItem>
                              ))}
                            </List>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.radioCartaoVacinacao?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Cartão Vacinação
                            </Text>
                            <Text p={1}>
                              <Text>
                                {props?.storage?.radioCartaoVacinacao.includes(
                                  "SIM",
                                ) && "Sim"}
                              </Text>
                              <Text>
                                {props?.storage?.radioCartaoVacinacao.includes(
                                  "NAO",
                                ) && "Não"}
                              </Text>
                              <Text>
                                {props?.storage?.radioCartaoVacinacao.includes(
                                  "SEM_INFORMACAO",
                                ) && "Sem Informação"}
                              </Text>
                            </Text>
                          </SimpleGrid>
                        )}
                        {(props?.storage?.medicacaoContinua?.length ?? 0) >
                          0 && (
                          <SimpleGrid columns={1} spacingY={3} w="100%" mt={10}>
                            {" "}
                            <Text
                              fontWeight="bold"
                              color="#169499"
                              borderBottom="1px solid #00000014"
                            >
                              Medicação Continua
                            </Text>
                            <Text p={1}>
                              {renderSN(props?.storage.medicacaoContinua)}
                            </Text>
                          </SimpleGrid>
                        )}
                      </Box>

                      <>
                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Educação
                          </Text>

                          {((props?.storage?.radioFrequentaEscola?.length ??
                            0) > 0 ||
                            (props?.storage?.radioEducacaoEspecial?.length ??
                              0) > 0 ||
                            (props?.storage?.radioEscolaridadeRepetida
                              ?.length ??
                              0)) > 0 && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}
                              {(props?.storage?.radioFrequentaEscola?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Frequenta Escola:{" "}
                                    {renderSN(
                                      props?.storage?.radioFrequentaEscola,
                                    )}
                                  </Text>
                                </Box>
                              )}

                              {(props?.storage?.radioEducacaoEspecial?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Educação Especial:{" "}
                                    {renderSN(
                                      props?.storage?.radioEducacaoEspecial,
                                    )}
                                  </Text>
                                </Box>
                              )}
                              {(props?.storage?.radioEscolaridadeRepetida
                                ?.length ?? 0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Escolaridade Repetida:{" "}
                                    {renderSN(
                                      props?.storage?.radioEscolaridadeRepetida,
                                    )}
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>

                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Profissionalização
                          </Text>

                          {((props?.storage?.radioPossuiCurso?.length ?? 0) >
                            0 ||
                            (props?.storage?.radioTrabalhaAtualmente?.length ??
                              0) > 0 ||
                            (props?.storage?.radioFazEstagio?.length ?? 0) >
                              0) && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}

                              {(props?.storage?.radioPossuiCurso?.length ?? 0) >
                                0 && (
                                <Box>
                                  <Text p={1}>
                                    Possui Curso Profissionalizante:{" "}
                                    {renderSN(props?.storage?.radioPossuiCurso)}
                                  </Text>
                                </Box>
                              )}
                              {(props?.storage?.radioTrabalhaAtualmente
                                ?.length ?? 0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Trabalha Atualmente:{" "}
                                    {renderSN(
                                      props?.storage?.radioTrabalhaAtualmente,
                                    )}
                                  </Text>
                                </Box>
                              )}
                              {(props?.storage?.radioFazEstagio?.length ?? 0) >
                                0 && (
                                <Box>
                                  <Text p={1}>
                                    Faz Estágio:{" "}
                                    {renderSN(props?.storage?.radioFazEstagio)}
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                          )}

                          {((props?.storage?.radioJovemAprendiz?.length ?? 0) >
                            0 ||
                            (props?.storage?.radioCurriculoVitae?.length ?? 0) >
                              0) && (
                            <SimpleGrid columns={3} spacing={3} w="100%">
                              {/* HEADER */}
                              {(props?.storage?.radioJovemAprendiz?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Matriculado no Programa Jovem Aprendiz:{" "}
                                    {renderSN(
                                      props?.storage?.radioJovemAprendiz,
                                    )}
                                  </Text>
                                </Box>
                              )}
                              {(props?.storage?.radioCurriculoVitae?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Possui Currículo Vitae:{" "}
                                    {renderSN(
                                      props?.storage?.radioCurriculoVitae,
                                    )}
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>

                        <>
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Visita
                          </Text>

                          {(props?.storage?.radioRecebeVisita?.length ?? 0) >
                            0 && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}

                              <Box>
                                <Text p={1}>
                                  Recebe Visita?{" "}
                                  {renderSN(props?.storage?.radioRecebeVisita)}
                                </Text>
                              </Box>
                            </SimpleGrid>
                          )}

                          {props?.storage?.faixaPeriodo && (
                            <SimpleGrid
                              columns={1}
                              spacingY={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}
                              <Text
                                fontWeight="bold"
                                color="#169499"
                                borderBottom="1px solid #00000014"
                              >
                                Faixa de Período
                              </Text>

                              <Text p={1}>
                                {props?.storage?.faixaPeriodo?.id === 1
                                  ? "No Mês"
                                  : props?.storage?.faixaPeriodo?.id === 2
                                    ? "Nos Últimos 3 Meses"
                                    : props?.storage?.faixaPeriodo?.id === 3
                                      ? "Nos Últimos 6 Meses"
                                      : props?.storage?.faixaPeriodo?.id === 4
                                        ? "Em Qualquer Período"
                                        : "Em Qualquer Período"}
                              </Text>
                            </SimpleGrid>
                          )}
                        </>

                        <>
                          <Box display="break-page">
                            <Text
                              borderBottom="3px solid #169499"
                              pb={2}
                              as="b"
                              fontSize={"18px"}
                              display="inline-flex"
                              alignItems="center"
                              gap={2}
                              mr={2}
                              mt={10}
                              w="fit-content"
                            >
                              <RiPushpinLine size={20} />
                              Situação Jurídica
                            </Text>

                            {(props?.storage?.radioPossuiProcessoJudicial
                              ?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {/* HEADER */}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Processo Judicial
                                </Text>

                                <Text p={1}>
                                  {renderSN(
                                    props?.storage.radioPossuiProcessoJudicial,
                                  )}
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.idProcesso?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Tipo de Processo Judicial
                                </Text>

                                <List styleType="disc" px={5}>
                                  {props?.storage.idProcesso[0].map((e) => (
                                    <ListItem key={e?.id}>
                                      {e?.descricao}
                                    </ListItem>
                                  ))}
                                </List>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.radioPossuiProcedimentoJudicial
                              ?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {/* HEADER */}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Procedimento Judicial
                                </Text>

                                <Text p={1}>
                                  {renderSN(
                                    props?.storage
                                      .radioPossuiProcedimentoJudicial,
                                  )}
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.idProcedimento?.length ?? 0) >
                              0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Tipo de Procedimento Judicial
                                </Text>

                                <List styleType="disc" px={5}>
                                  {props?.storage.idProcedimento[0].map((e) => (
                                    <ListItem key={e?.id}>
                                      {e?.descricao}
                                    </ListItem>
                                  ))}
                                </List>
                              </SimpleGrid>
                            )}
                            {(props?.storage?.radioDecisaoLiminar?.length ??
                              0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Decisão Liminar
                                </Text>
                                <Text p={1}>
                                  {renderSN(props?.storage.radioDecisaoLiminar)}
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.radioSentenca?.length ?? 0) >
                              0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Sentença
                                </Text>
                                <Text p={1}>
                                  {renderSN(props?.storage.radioSentenca)}
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.idTipoSentenca?.length ?? 0) >
                              0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Tipo de Sentença
                                </Text>
                                <List styleType="disc" px={5}>
                                  {props?.storage.idTipoSentenca[0].map((e) => (
                                    <ListItem key={e.id}>
                                      {e?.descricao}
                                    </ListItem>
                                  ))}
                                </List>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.recurso?.length ?? 0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Recurso
                                </Text>
                                <Text p={1}>
                                  <Text>
                                    {props?.storage?.recurso === "S" && "Sim"}
                                  </Text>
                                  <Text>
                                    {props?.storage?.recurso === "N" && "Não"}
                                  </Text>
                                  <Text>
                                    {props?.storage?.recurso === "I" &&
                                      "Sem Informação"}
                                  </Text>
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.radioTransitoJulgado?.length ??
                              0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Trânsito em Julgado
                                </Text>
                                <Text p={1}>
                                  {renderSN(
                                    props?.storage.radioTransitoJulgado,
                                  )}
                                </Text>
                              </SimpleGrid>
                            )}

                            {(props?.storage?.radioDecisaoLiminar?.length ??
                              0) > 0 && (
                              <SimpleGrid
                                columns={1}
                                spacingY={3}
                                w="100%"
                                mt={10}
                              >
                                {" "}
                                <Text
                                  fontWeight="bold"
                                  color="#169499"
                                  borderBottom="1px solid #00000014"
                                >
                                  Medicação Continua
                                </Text>
                                <Text p={1}>
                                  {renderSN(props?.storage.radioDecisaoLiminar)}
                                </Text>
                              </SimpleGrid>
                            )}
                          </Box>

                          <Box display="break-page">
                            <Text
                              borderBottom="3px solid #169499"
                              pb={2}
                              as="b"
                              fontSize={"18px"}
                              display="inline-flex"
                              alignItems="center"
                              gap={2}
                              mr={2}
                              mt={10}
                              w="fit-content"
                            >
                              <RiPushpinLine size={20} />
                              Situação quanto à adoção
                            </Text>

                            {(props?.storage?.radioCumpreRequisito?.length ??
                              0) > 0 && (
                              <SimpleGrid
                                columns={3}
                                spacing={3}
                                w="100%"
                                mt={10}
                              >
                                {/* HEADER */}

                                <Box>
                                  <Text p={1}>
                                    Cumpre Requisitos para Adoção:{" "}
                                    {renderSN(
                                      props?.storage?.radioCumpreRequisito,
                                    )}
                                  </Text>
                                </Box>
                              </SimpleGrid>
                            )}
                          </Box>
                        </>

                        <Box display="break-page">
                          <Text
                            borderBottom="3px solid #169499"
                            pb={2}
                            as="b"
                            fontSize={"18px"}
                            display="inline-flex"
                            alignItems="center"
                            gap={2}
                            mr={2}
                            mt={10}
                            w="fit-content"
                          >
                            <RiPushpinLine size={20} />
                            Programa de Apadrinhamento
                          </Text>

                          {((props?.storage?.radioIncluidoPrograma?.length ??
                            0) > 0 ||
                            (props?.storage?.radioSendoApadrinhado?.length ??
                              0) > 0) && (
                            <SimpleGrid
                              columns={3}
                              spacing={3}
                              w="100%"
                              mt={10}
                            >
                              {/* HEADER */}

                              {(props?.storage?.radioIncluidoPrograma?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Está Incluído no Programa de Apadrinhamento:{" "}
                                    <Text>
                                      {props?.storage?.radioIncluidoPrograma ===
                                        "S" && "Sim"}
                                    </Text>
                                    <Text>
                                      {props?.storage?.radioIncluidoPrograma ===
                                        "N" && "Não"}
                                    </Text>
                                    <Text>
                                      {props?.storage?.radioIncluidoPrograma ===
                                        "SI" && "Sem Informação"}
                                    </Text>
                                  </Text>
                                </Box>
                              )}
                              {(props?.storage?.radioSendoApadrinhado?.length ??
                                0) > 0 && (
                                <Box>
                                  <Text p={1}>
                                    Está Sendo Apadrinhado:{" "}
                                    <Text>
                                      {props?.storage?.radioSendoApadrinhado ===
                                        "S" && "Sim"}
                                    </Text>
                                    <Text>
                                      {props?.storage?.radioSendoApadrinhado ===
                                        "N" && "Não"}
                                    </Text>
                                    <Text>
                                      {props?.storage?.radioSendoApadrinhado ===
                                        "SI" && "Sem Informação"}
                                    </Text>
                                  </Text>
                                </Box>
                              )}
                            </SimpleGrid>
                          )}
                        </Box>
                      </>
                    </Flex>
                  </Box>
                </Box>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                {/* Footer Spacer */}
                <Box height="150px" />
              </td>
            </tr>
          </tfoot>
        </table>

        {/* Header */}
        <HStack
          position="fixed"
          top={0}
          pt="17.5px"
          pl={"50px"}
          pb="10px"
          alignItems="end"
          justifyContent="space-between"
          backgroundColor="#FFF"
          zIndex={100}
          width="100%"
          borderBottom="solid 1px #D1D0CF"
        >
          <img
            src={logoMCA}
            alt="LogoMCA"
            style={{ width: "200px", height: "60px" }}
          />

          <Box width="200px" />
        </HStack>
        {/* Footer */}
        <Box
          position="fixed"
          bottom={10}
          pb="17.5px"
          pt="20px"
          w="100%"
          px="15px"
          backgroundColor="#006064"
          zIndex={100}
        >
          <Text color={"#fff"}>Usuário: {props?.user?.name}</Text>
          <Text color={"#fff"}>
            Orgão: {props?.dados?.nomeOrgao || props?.dados?.nomeOrgaoExterno}
          </Text>
          <Text color={"#fff"}>{`Data da impressão: ${format(
            new Date(),
            "dd/MM/yyyy",
          )} ${format(new Date(), "HH:mm:ss")}`}</Text>
        </Box>
        <Flex
          position="fixed"
          bottom={0}
          pt="10px"
          w="100%"
          px="15px"
          backgroundColor="#FFF"
          zIndex={100}
        >
          <HStack spacing="35px">
            <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
            <Text>{format(new Date(), "HH:mm:ss")}</Text>
          </HStack>

          <Spacer />

          <Text id="pageForPrint">Página</Text>
        </Flex>
      </Box>
    );
  },
);
